import styled from 'styled-components';

export const Spacer = styled.div`
  width: 100%;
  height: ${({ height }) => height || '2rem'};
`;